export default "__VITE_ASSET__020eb145__"